import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=25489751&scoped=true&"
import script from "./NavMenu.vue?vue&type=script&lang=ts&"
export * from "./NavMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NavMenu.vue?vue&type=style&index=0&id=25489751&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25489751",
  null
  
)

component.options.__file = "NavMenu.vue"
export default component.exports